import React, { Component } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import logo from "../../images/Ofx_logo.png";


const styles = {
    activeStyle: {
        backgroundColor: "#fff",
        boxShadow: "0px 0px 3px rgb(107,106,106)",
       fontWeight:"500"
    }
}

class AdminNavbar extends Component {

    handleLogout = () =>{
        localStorage.clear()
    }

    componentDidMount(){
         JSON.parse(localStorage.getItem("expiryTime"))
        // let expiryTime = new Date(expiry)
        // let time = expiryTime.getTime()
        let _this = this

        if (localStorage.getItem('timeoutvalue') === "first") {
            this.Interval = setTimeout(function () {
                // let currentDate = new Date();
                // var current = currentDate.getTime();
                // if (time <= current) {
                clearInterval(this.Interval)

                localStorage.clear();
                _this.props.history.push("/sessionout")

            }, 1800000)
            localStorage.setItem('timeoutvalue','second')
            this.setState({
                Interval: this.Interval,
            })
        }
    }
    componentWillUnmount() {
        let expiry = JSON.parse(localStorage.getItem("expiryTime"))
        let expiryTime = new Date(expiry)
        let time = expiryTime.getTime()
        let currentDate = new Date();
        var current1 = currentDate.getTime();

        if (time <= current1) {

            clearInterval(this.Interval)
        }
    }
    render() {
        // const logo = getUser().logo
        return (
            
            <nav className="navbar navbar-expand-sm bg-trans navbar-dark fixed-top" >
             
                   {/* <Link to="/cardsearch" className="navbar-brand" href="#"><img  src={ require(`../../images/${ logo }/logo.jpg`) } alt='' style={{ height: 60,  }} /></Link> */}
                 <Link to="/cardsearch" className="navbar-brand" href="#"><img src={logo} alt='' style={{ height: 65,}} /></Link>
                <ul className="nav justify-content-end" style={{ width: "100%" }}>
                    <li className="nav-item nav-tab-padding " style={{ width: "13%" }}>
                        <NavLink 
                         onClick={this.handleLogout.bind(this)}
                        to="/"
                         activeStyle={styles.activeStyle}  
                         className="nav-link text-dark">
                            Log Out
                        </NavLink>
                    </li>
                </ul>
            </nav>
        );
    }
}

export default withRouter(AdminNavbar);


// WEBPACK FOOTER //
// ./src/components/navigation/adminnavigation.jsx